// Единая ошибка сетевого слоя. `code` — бизнес-код ошибки из тела ответа бэкенда
// (когда контракты появятся в @lunya/contracts, сюда можно подставить их union).

export type HttpErrorPayload = {
  status: number
  message: string
  code?: string
  details?: unknown
}

export class HttpError extends Error {
  readonly status: number
  readonly code?: string
  readonly details?: unknown

  constructor(payload: HttpErrorPayload) {
    super(payload.message)

    this.name = 'HttpError'
    this.status = payload.status
    this.code = payload.code
    this.details = payload.details
  }
}

export function isHttpError(error: unknown): error is HttpError {
  return error instanceof HttpError
}
